import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerDots',
  props: {
    delay: { default: 0 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})